namespace GeniuzPOS.PosShift {
    export interface PsPosShiftControlRow {
        Id?: number;
        SingInDate?: string;
        SingInTime?: string;
        SingOutDate?: string;
        SingOutTime?: string;
        ShiftStatus?: string;
        PosId?: string;
        ShopId?: string;
        ShopFullName?: string;
        CashierId?: string;
        StartReceiptNo?: string;
        EndReceiptNo?: string;
        StartRefundNo?: string;
        EndRefundNo?: string;
        BegCash?: number;
        CashIn?: number;
        CashOut?: number;
        CashSales?: number;
        RoundReceive?: number;
        CashBalance?: number;
        GrossAmt?: number;
        Deiscount?: number;
        NetSales?: number;
        Charge?: number;
        RecvByCash?: number;
        RecvByCoupon?: number;
        RecvByCreditCd?: number;
        RecvByDebitCd?: number;
        RecvByPoint?: number;
        RecvByCashCd?: number;
        RecvByOthers?: number;
        CountVoid?: number;
        CountCancel?: number;
        CountOpenDrawer?: number;
        CountCashIn?: number;
        CountCashOut?: number;
        CountRefund?: number;
        TotalVoidAmt?: number;
        TotalCashInAmt?: number;
        TotalCashOutamt?: number;
        TotalRefundAmt?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsPosShiftControlRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShiftStatus';
        export const localTextPrefix = 'PosShift.PsPosShiftControl';
        export const lookupKey = 'PosShift.PsPosShiftControl';

        export function getLookup(): Q.Lookup<PsPosShiftControlRow> {
            return Q.getLookup<PsPosShiftControlRow>('PosShift.PsPosShiftControl');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายงานสถานะกะแคชเชียร์:View';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            SingInDate = "SingInDate",
            SingInTime = "SingInTime",
            SingOutDate = "SingOutDate",
            SingOutTime = "SingOutTime",
            ShiftStatus = "ShiftStatus",
            PosId = "PosId",
            ShopId = "ShopId",
            ShopFullName = "ShopFullName",
            CashierId = "CashierId",
            StartReceiptNo = "StartReceiptNo",
            EndReceiptNo = "EndReceiptNo",
            StartRefundNo = "StartRefundNo",
            EndRefundNo = "EndRefundNo",
            BegCash = "BegCash",
            CashIn = "CashIn",
            CashOut = "CashOut",
            CashSales = "CashSales",
            RoundReceive = "RoundReceive",
            CashBalance = "CashBalance",
            GrossAmt = "GrossAmt",
            Deiscount = "Deiscount",
            NetSales = "NetSales",
            Charge = "Charge",
            RecvByCash = "RecvByCash",
            RecvByCoupon = "RecvByCoupon",
            RecvByCreditCd = "RecvByCreditCd",
            RecvByDebitCd = "RecvByDebitCd",
            RecvByPoint = "RecvByPoint",
            RecvByCashCd = "RecvByCashCd",
            RecvByOthers = "RecvByOthers",
            CountVoid = "CountVoid",
            CountCancel = "CountCancel",
            CountOpenDrawer = "CountOpenDrawer",
            CountCashIn = "CountCashIn",
            CountCashOut = "CountCashOut",
            CountRefund = "CountRefund",
            TotalVoidAmt = "TotalVoidAmt",
            TotalCashInAmt = "TotalCashInAmt",
            TotalCashOutamt = "TotalCashOutamt",
            TotalRefundAmt = "TotalRefundAmt",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
